var _path, _ellipse, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _path3, _path4, _ellipse2, _ellipse3, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 160,
    viewBox: "0 0 164 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148 30H18C15.7909 30 14 31.7909 14 34V122C14 124.209 15.7909 126 18 126H148C150.209 126 152 124.209 152 122V34C152 31.7909 150.209 30 148 30Z",
    stroke: "#053668",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 82,
    cy: 130,
    rx: 82,
    ry: 4,
    fill: "#053668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33C14 31.3431 15.3431 30 17 30H149C150.657 30 152 31.3431 152 33V39H14V33Z",
    fill: "#053668"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 34,
    r: 2,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 34,
    r: 2,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 34,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.933,
    cy: 76.0365,
    r: 4.03652,
    fill: "#053668"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.298,
    cy: 76.0365,
    r: 4.03652,
    fill: "#053668"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7003 70.7233C65.7003 70.7233 64.0271 72.2064 61.1293 72.9829C58.2316 73.7593 56.041 73.3115 56.041 73.3115",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.3 70.7233C100.3 70.7233 101.973 72.2064 104.871 72.9829C107.768 73.7593 109.959 73.3115 109.959 73.3115",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 62.9335,
    cy: 84.1097,
    rx: 4.93353,
    ry: 2.24251,
    fill: "#053668"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 103.299,
    cy: 84.1097,
    rx: 4.93353,
    ry: 2.24251,
    fill: "#053668"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.394 89.9404C88.497 87.2494 86.0874 85.4554 83.115 85.4554C80.1426 85.4554 77.7329 87.2494 76.8359 89.9404",
    stroke: "#053668",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadPageIcon);
export default __webpack_public_path__ + "static/media/sad-page-icon.f64f44323359c8e093b5fed3c23e2c6d.svg";
export { ForwardRef as ReactComponent };